import { render, staticRenderFns } from "./EditAchatFrais.vue?vue&type=template&id=2b4e90e8&"
import script from "./EditAchatFrais.vue?vue&type=script&lang=ts&"
export * from "./EditAchatFrais.vue?vue&type=script&lang=ts&"
import style0 from "./EditAchatFrais.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports